//excel upload modal (image)
/* eslint-disable react/button-has-type */
import React from "react";
import PropTypes from "prop-types";
import { Box, Modal } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import styles from "./UpdateStrategyModal.module.scss";
import clsx from "clsx";
import { commonVaribles } from "src/constants/constVariables";
import { Loader } from "src/components/Loader";
import CloudUploadIcon from "src/assets/images/icons/CloudUploadIcon.svg";
import FileIcon from "src/assets/images/icons/FileIcon.svg";
import FileCrossIcon from "src/assets/images/icons/FileCross.svg";
import { Button } from "src/components/Atoms";
import { constants } from "src/constants/constant";
import useAuthorizationContext from "src/providers/AuthorizationHandler/useAuthorizationContext";
import { hasEditAccess } from 'src/authorization/authorizationsConstants';

export const UpdateStrategyModal = ({
  open,
  title,
  handleClose,
  confirmUpload,
  openUploadFile,
  imageData,
  errorMsg,
  handleDrop,
  onDragOver,
  excelfiles,
  Modalloader,
  setExcel,
}) => {
  //func for displaying the file name
  const { user } = useAuthorizationContext();
  const removeExcelFile = () => {
    setExcel(null);
  };

  //make sure to add those common variables text in the commonvariable.js file. all the common variables are marked with "//" which needs adding.
  return (
    <Modal open={open} onClose={handleClose} className={styles.modalstyle}>
      <div className={styles.containerstyle}>
        <div className={styles["title-div"]}>
          <h1 className={styles.titleStyle}>{title}</h1>
          <div className={styles.closeIconStyle}>
            <CloseIcon onClick={handleClose} />
          </div>
        </div>
        {Modalloader && (
          <div className={styles["loader-div"]}>
            <Loader />
          </div>
        )}
        <div style={{ width: "100%", height: 1, backgroundColor: "#6F6F6F" }} />
        <div className={styles.mainbody}>
          <div className={styles["error-msg"]}>
            <div>
              {errorMsg && <span className={styles["note"]}>{errorMsg}</span>}
            </div>
          </div>
          <div onDrop={handleDrop} onDragOver={onDragOver} draggable={true}>
            {hasEditAccess(
              user,
              commonVaribles.download_packaging_strategy
            ) && (
              <div className={styles.subsection}>
                <Button
                  children={commonVaribles.excel_update_download_strategy}
                  variant={constants.BUTTON_ATOMIC_COMPONENT.PRIMARY}
                  // onClick={() => {
                  //   setIsFeedBackModalOpen(true);
                  // }}
                />
              </div>
            )}
            <Box
              bgcolor="#dadada3d"
              marginTop="13px"
              height="10rem"
              width="100%"
            >
              <div className={clsx(styles.warningText)}>
                {excelfiles && (
                  <div className={styles["file-name-container"]}>
                    <img
                      className={styles["file-icon"]}
                      src={FileIcon}
                      alt="File-Icon"
                    />
                    <div className={styles["file-details"]}>
                      <div className={styles["file-name"]}>
                        {excelfiles.name}
                      </div>
                      <div className={styles["file-size"]}>
                        {excelfiles.size} Kb
                      </div>
                    </div>
                    <img
                      className={styles["file-cross-icon"]}
                      src={FileCrossIcon}
                      alt="File-Cross-Icon"
                      onClick={() => {
                        removeExcelFile();
                      }}
                    />
                  </div>
                )}
                {!Modalloader && !excelfiles && (
                  <div
                    onClick={openUploadFile}
                    className={styles["warning-Text"]}
                  >
                    <img
                      className={styles["upload-icon"]}
                      src={CloudUploadIcon}
                      alt="CloudUpload-Icon"
                    />
                    <span className={styles["upload-text"]}>
                      {commonVaribles.strategy_excel_upload_title}
                    </span>
                  </div>
                )}
              </div>
            </Box>
          </div>
          <div className={styles["model-footer"]}>
            <div
              style={{ display: "flex", flexDirection: "column", width: "70%" }}
            >
              <span className={styles["note"]}>{commonVaribles.note}</span>
              <span className={styles["note"]}>
                {commonVaribles.excel_update_note_1}
              </span>
              <span className={styles["note"]}>
                {commonVaribles.excel_update_note_2}
              </span>
              <span className={styles["note"]}>
                {commonVaribles.excel_update_note_3}
              </span>
            </div>
            <div className={styles.bottomRow}>
              <button
                className={clsx(styles.cancelBt, "regularFont")}
                onClick={handleClose}
              >
                {commonVaribles.cancel}
              </button>
              <span>
                <button
                  onClick={() => {
                    confirmUpload(imageData);
                  }}
                  className={clsx(styles.uploadBt, "regularFont")}
                  disabled={!excelfiles}
                >
                  {commonVaribles.upload}
                </button>
              </span>
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
};

//few props are commented out since they would be required for uploading mutliple excel files and not only a single file.
UpdateStrategyModal.propTypes = {
  title: PropTypes.string.isRequired,
  open: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
  //confirmUpload: PropTypes.func.isRequired,
  openUploadFile: PropTypes.func.isRequired,
  //imageData: PropTypes.array.isRequired,
  //handleRemoveImg: PropTypes.func.isRequired,
  errorMsg: PropTypes.string,
  addmore: PropTypes.func.isRequired,
  //removeAll: PropTypes.func.isRequired,
  //handleDrop: PropTypes.func.isRequired,
  //onDragOver: PropTypes.func.isRequired,
};
